import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Strip "Q " prefix from Milon device names (e.g. "Q Leg Press" → "Leg Press") */
export function cleanDeviceName(name: string): string {
  return name.replace(/^Q\s+/, '').trim()
}

/**
 * The "no value here" glyph — an **en dash**, not an em dash.
 *
 * PRODUCT.md's anti-references ban em dashes anywhere in UI copy. That rule is
 * aimed at sentence punctuation, but the null placeholder used to be an em dash
 * too, so it read as a violation at every glance and invited the same edit over
 * and over. An en dash is the conventional table mark for "no data" and keeps
 * numeric columns quiet.
 *
 * Exported as a constant on purpose: `AppleHealthTab` styles a cell by
 * comparing its value against this string, so a hardcoded copy that drifted
 * from the formatters' output would silently stop dimming empty cells — a
 * green build with a wrong render. One definition makes that drift impossible.
 */
export const NO_VALUE = '–'
